/* Wines & Flowers · Produktseite (v1, 26.10.2026; Farbfilter der Galerie (Bühne + Struktur) 31.10.2026; 3D-Farbe und Raumansicht 27.10.2026; 3D erst beim Öffnen laden, Raumansicht nach QR-Scan 28.10.2026) – gehört zu sections/wf-produkt.liquid */
(function () {
  function init(root) {
    if (!root || root.__wfP) return;
    root.__wfP = true;
    var dataEl = root.querySelector('[data-wf-json]');
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };

    /* Geld */
    function money(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try { return Shopify.formatMoney(cents, data.moneyFormat); } catch (e) {}
      }
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }

    /* Galerie */
    var track = $('[data-wf-track]');
    var allSlides = $$('[data-wf-slide]');
    var allDots = $$('.wf-p__dots span');
    var allThumbs = $$('[data-wf-thumb]');
    var shown = function (e) { return !e.hidden; };
    var slides = allSlides.filter(shown);
    var dots = allDots.filter(shown);
    var thumbs = allThumbs.filter(shown);
    var current = 0;
    /* Farbfilter: Nur Farbbilder (Bühne, Struktur – im Theme per Alt-Text markiert als data-wf-color) wechseln mit der Farbe.
       Alle anderen Bilder bleiben sichtbar. Hat die Farbe keine Farbbilder, gelten die der ersten Farbe.
       Gibt true zurück, wenn sich etwas geändert hat. */
    function handle(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
    function setVis(e, on) { e.hidden = !on; e.style.display = on ? '' : 'none'; }
    var colorNow = null;
    function filterColor(v) {
      if (!v || !(data.colorIndex >= 0) || !allSlides.length) return false;
      var c = handle(v.options[data.colorIndex]);
      if (c === colorNow) return false;
      colorNow = c;
      var tagged = allSlides.filter(function (s) { return s.hasAttribute('data-wf-color'); });
      var hits = tagged.some(function (s) { return s.getAttribute('data-wf-color') === c; });
      var show = hits ? c : (tagged[0] ? tagged[0].getAttribute('data-wf-color') : '');
      var vis = function (e) { var k = e.getAttribute('data-wf-color'); return !k || k === show; };
      allSlides.forEach(function (s) { setVis(s, vis(s)); });
      allThumbs.forEach(function (t) { setVis(t, vis(t)); });
      slides = allSlides.filter(shown);
      thumbs = allThumbs.filter(shown);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-label', 'Bild ' + (k + 1) + ' anzeigen'); });
      allDots.forEach(function (d, k) { setVis(d, k < slides.length); });
      dots = allDots.filter(shown);
      var many = slides.length > 1;
      $$('[data-wf-prev],[data-wf-next],.wf-p__dots,.wf-p__thumbs').forEach(function (e) { e.style.visibility = many ? '' : 'hidden'; });
      return true;
    }
    function go(i, smooth) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        if (k === i && t.parentNode && t.parentNode.scrollTo) {
          var p = t.parentNode;
          var left = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
          p.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
      });
    }
    if (track) {
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) mark(Math.min(i, slides.length - 1));
        });
      }, { passive: true });
    }
    var prev = $('[data-wf-prev]'), next = $('[data-wf-next]');
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = slides.indexOf(allSlides[Number(t.getAttribute('data-wf-thumb'))]);
        if (i >= 0) go(i);
      });
    });

    /* Varianten */
    var form = $('[data-wf-form]');
    var idInput = $('[data-wf-id]');
    var sel = [];
    var first = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0];
    if (first) sel = first.options.slice();
    filterColor(first);

    function find() {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function hasSockel(v) {
      if (!v || data.sockelIndex < 0) return false;
      return String(v.options[data.sockelIndex] || '').toLowerCase().indexOf('ohne') === -1;
    }
    function apply(v, push) {
      var addBtn = $('[data-wf-add]'), addLabel = $('[data-wf-add-label]');
      var stock = $('[data-wf-stock]'), stT = $('[data-wf-stock-title]'), stX = $('[data-wf-stock-text]');
      var barAdd = $('[data-wf-bar-add]');
      if (!v) {
        if (addBtn) addBtn.disabled = true;
        if (addLabel) addLabel.textContent = 'Nicht verfügbar';
        if (barAdd) barAdd.disabled = true;
        if (stock) stock.classList.add('is-out');
        if (stT) stT.textContent = 'Gerade nicht verfügbar';
        if (stX) stX.textContent = 'Wähle eine andere Ausführung';
        return;
      }
      sel = v.options.slice();
      if (idInput) idInput.value = v.id;
      var p = $('[data-wf-price]'); if (p) p.textContent = money(v.price);
      var c = $('[data-wf-compare]');
      if (c) { var sale = v.compare > v.price; c.hidden = !sale; c.textContent = sale ? money(v.compare) : ''; }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (barAdd) barAdd.disabled = !v.available;
      var bl = $('[data-wf-bar-label]'); if (bl) bl.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      if (stock) stock.classList.toggle('is-out', !v.available);
      if (stT) stT.textContent = v.available ? 'Jetzt bestellbar' : 'Gerade nicht verfügbar';
      if (stX) stX.textContent = v.available ? 'Lieferung in 4–7 Werktagen mit DHL' : 'Wähle eine andere Ausführung';
      $$('[data-wf-sku]').forEach(function (e) { e.textContent = v.sku || 'Nicht angegeben'; });
      $$('[data-wf-variant-title]').forEach(function (e) { e.textContent = v.title; });
      var bp = $('[data-wf-bar-price]'); if (bp) bp.textContent = money(v.price);
      var bv = $('[data-wf-bar-variant]'); if (bv) bv.textContent = v.title;
      var s = hasSockel(v);
      $$('[data-wf-sockel-only]').forEach(function (e) { e.hidden = !s; });
      var scope = $('[data-wf-scope]');
      if (scope && data.sockelIndex >= 0) {
        scope.textContent = s ? 'Weinflaschenhalter, Bambus-Sockel mit Silikonfüßen, Schrauben und Inbusschlüssel' : 'Weinflaschenhalter';
      }
      v.options.forEach(function (o, i) {
        $$('[data-wf-opt="' + i + '"]').forEach(function (b) {
          var on = b.getAttribute('data-wf-val') === o;
          b.classList.toggle('is-on', on);
          if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var ch = $('[data-wf-chosen="' + i + '"]'); if (ch) ch.textContent = o;
      });
      var changed = filterColor(v);
      var idx = v.media ? slides.map(function (sl) { return sl.getAttribute('data-media-id'); }).indexOf(String(v.media)) : -1;
      if (idx >= 0) go(idx, !changed);
      else if (changed) go(0, false);
      raumUpdate();
      if (push && window.history && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
      }
    }
    $$('[data-wf-opt][data-wf-val]').forEach(function (b) {
      b.addEventListener('click', function () {
        sel[Number(b.getAttribute('data-wf-opt'))] = b.getAttribute('data-wf-val');
        apply(find(), true);
        if (b.hasAttribute('data-wf-scrollup')) {
          var buy = $('.wf-p__buy');
          if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    /* Menge */
    var q = $('[data-wf-qty]');
    function qv() { var n = parseInt(q && q.value, 10); return n > 0 ? n : 1; }
    var minus = $('[data-wf-minus]'), plus = $('[data-wf-plus]');
    if (minus) minus.addEventListener('click', function () { q.value = Math.max(1, qv() - 1); });
    if (plus) plus.addEventListener('click', function () { q.value = qv() + 1; });
    if (q) q.addEventListener('blur', function () { q.value = qv(); });

    /* Reiter */
    var tabs = $$('[data-wf-tab]');
    function openTab(t, focus) {
      tabs.forEach(function (b) {
        var on = b === t;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        var pan = $('[data-wf-panel="' + b.getAttribute('data-wf-tab') + '"]');
        if (pan) pan.hidden = !on;
      });
      if (focus) t.focus();
      if (t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) {
        t.parentNode.scrollTo({ left: t.offsetLeft - 16, behavior: 'smooth' });
      }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { openTab(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); openTab(tabs[(i + 1) % tabs.length], true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); openTab(tabs[(i - 1 + tabs.length) % tabs.length], true); }
      });
    });

    /* Punkte im Bild */
    var spots = $$('.wf-p__spot');
    function closeSpots(except) {
      spots.forEach(function (s) {
        if (s === except) return;
        s.classList.remove('is-open');
        var b = s.querySelector('[data-wf-dot]'); if (b) b.setAttribute('aria-expanded', 'false');
        var t = s.querySelector('.wf-p__tip'); if (t) t.hidden = true;
      });
    }
    var card = $('[data-wf-hs-card]'), cardBody = card && card.querySelector('[data-wf-hs-body]');
    function fillCard(s, t) {
      if (!card) return;
      if (!t) { card.hidden = true; cardBody.innerHTML = ''; return; }
      cardBody.innerHTML = t.innerHTML;
      card.classList.toggle('is-top', parseFloat(s.getAttribute('data-wf-y') || '0') > 55);
      card.hidden = true; void card.offsetWidth; card.hidden = false;
    }
    spots.forEach(function (s) {
      var b = s.querySelector('[data-wf-dot]'), t = s.querySelector('.wf-p__tip');
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = !s.classList.contains('is-open');
        closeSpots(s);
        s.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        t.hidden = !open;
        fillCard(s, open ? t : null);
      });
    });
    if (card) {
      card.addEventListener('click', function (e) { e.stopPropagation(); });
      var cx = card.querySelector('[data-wf-hs-x]');
      if (cx) cx.addEventListener('click', function () { closeSpots(); fillCard(null, null); });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.wf-p__spot')) { closeSpots(); fillCard(null, null); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSpots(); fillCard(null, null); } });

    /* Kaufleiste (Handy und Desktop) */
    var bar = $('[data-wf-bar]'), actions = $('[data-wf-actions]');
    if (bar && actions && 'IntersectionObserver' in window) {
      var past = false;
      new IntersectionObserver(function (en) {
        var e = en[0];
        past = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', past);
        document.body.classList.toggle('wf-p-bar-on', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        [].slice.call(bar.querySelectorAll('button')).forEach(function (x) { x.tabIndex = past ? 0 : -1; });
      }, { threshold: 0 }).observe(actions);
      var barAdd = bar.querySelector('[data-wf-bar-add]');
      if (barAdd) barAdd.addEventListener('click', function () {
        if (barAdd.disabled || !form) return;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    /* Teilen */
    var share = $('[data-wf-share]');
    if (share) share.addEventListener('click', function () {
      if (navigator.share) { navigator.share({ title: data.title, url: location.href }).catch(function () {}); return; }
      if (navigator.clipboard) {
        navigator.clipboard.writeText(location.href).then(function () {
          share.setAttribute('aria-label', 'Link kopiert');
          setTimeout(function () { share.setAttribute('aria-label', 'Produkt teilen'); }, 1800);
        }).catch(function () {});
      }
    });

    /* Sicherheitshinweise */
    var safe = $('[data-wf-safety]'), sOpen = $('[data-wf-safety-open]'), lastFocus = null;
    function closeSafe() { if (!safe || safe.hidden) return; safe.hidden = true; document.body.classList.remove('wf-p-lock'); if (lastFocus) lastFocus.focus(); }
    if (safe && sOpen) {
      sOpen.addEventListener('click', function () {
        lastFocus = sOpen; safe.hidden = false; document.body.classList.add('wf-p-lock');
        var x = safe.querySelector('.wf-p__modal-x'); if (x) x.focus();
      });
      $$('[data-wf-safety-close]').forEach(function (b) { b.addEventListener('click', closeSafe); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSafe(); });
    }

    /* 3D-Modell (Knopf „3D-Modell“ in der Galerie)
       Pro Farbe liegt ein eigenes 3D-Modell am Produkt (Alt-Text enthält den Farbnamen,
       z. B. „VYRA 3D · Light Ash Marble“). Beim Öffnen wird das Modell der gewählten Farbe geladen.
       Ohne passendes Modell bleibt das Standardmodell aus der Section. */
    var modal = $('[data-wf-model]'), mOpen = $('[data-wf-model-open]');
    var modelsP = null, modelsList = null;
    function loadModels() {
      if (modelsP) return modelsP;
      var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
      if (!h || !window.fetch) { modelsP = Promise.resolve([]); return modelsP; }
      var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var url = rootUrl + 'products/' + h + '.js';
      var get = function () { return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw r; return r.json(); }); };
      /* Ein zweiter Versuch nach kurzer Pause, falls der Shop die Anfrage einmal ablehnt (z. B. 429) */
      modelsP = get()
        .catch(function () { return new Promise(function (ok) { setTimeout(ok, 1500); }).then(get); })
        .then(function (p) {
          return ((p && p.media) || []).filter(function (m) { return m.media_type === 'model' && m.alt; }).map(function (m) {
            var glb = (m.sources || []).filter(function (s) { return s.format === 'glb'; })[0];
            var usdz = (m.sources || []).filter(function (s) { return s.format === 'usdz'; })[0];
            var pv = m.preview_image && (m.preview_image.src || m.preview_image.url);
            return {
              alt: String(m.alt).toLowerCase(),
              name: String(m.alt).split(/\s+3D\b/)[0].trim(),
              src: glb ? glb.url : '',
              usdz: usdz ? usdz.url : '',
              preview: pv || ''
            };
          }).filter(function (m) { return m.src; });
        })
        .catch(function () { return []; })
        .then(function (list) { modelsList = list; return list; });
      return modelsP;
    }
    /* Bestes Modell zur Auswahl: das, dessen Alt-Text die meisten gewählten Optionen enthält
       (z. B. „MANUS 3D · Black Onyx · Mit Bambus-Sockel“). Farbe = erste passende Option. */
    function modelFor(list) {
      var best = null, bestScore = 0, bestColor = '';
      for (var k = 0; k < list.length; k++) {
        var score = 0, color = '';
        for (var i = 0; i < sel.length; i++) {
          var o = String(sel[i] || '');
          if (o && list[k].alt.indexOf(o.toLowerCase()) !== -1) { score++; if (!color) color = o; }
        }
        if (score > bestScore) { best = list[k]; bestScore = score; bestColor = color; }
      }
      return best ? { src: best.src, color: bestColor, m: best } : null;
    }
    function colorLabel() {
      var brand = modal.querySelector('.wf-p__modal-brand');
      if (!brand) return null;
      var l = brand.querySelector('[data-wf-model-color]');
      if (!l) {
        brand.style.right = '72px'; /* lange Titel brechen um, statt unter den Schließen-Knopf zu laufen */
        l = document.createElement('small');
        l.setAttribute('data-wf-model-color', '');
        l.style.cssText = 'font:inherit;color:inherit';
        brand.appendChild(l);
      }
      return l;
    }
    /* Dunkle Farben bekommen den hellen Bildkasten-Ton (#E4E0DA), alle anderen bleiben auf Dunkel */
    var LIGHT_BG = ['midnight black', 'deep navy', 'black onyx'];
    function lightStyle() {
      if (document.getElementById('wf-p-model-light')) return;
      var st = document.createElement('style');
      st.id = 'wf-p-model-light';
      st.textContent =
        '.wf-p__modal-box{transition:background .3s ease;box-sizing:border-box;padding-bottom:64px}' +
        '.wf-p__modal-box.is-light{background:radial-gradient(110% 85% at 50% 42%,#EFEBE5 0%,#E4E0DA 75%)}' +
        '.wf-p__modal-box.is-light .wf-p__modal-brand{color:#15120F}' +
        '.wf-p__modal-box.is-light .wf-p__modal-x{background:#fff;border-color:rgba(23,23,23,.13);color:#171717!important}' +
        '.wf-p__modal-box.is-light [data-wf-model-loading]{color:rgba(23,20,16,.64)!important}' +
        '.wf-p__modal-note{position:absolute;left:20px;right:20px;bottom:14px;min-height:46px;display:flex;align-items:center;justify-content:center;z-index:2;margin:0;text-align:center;font-size:16px;line-height:1.4;color:rgba(249,248,246,.72);pointer-events:none}' +
        '.wf-p__modal-box.is-light .wf-p__modal-note{color:rgba(21,18,15,.7)}';
      document.head.appendChild(st);
    }
    function setBg(color) {
      var box = modal.querySelector('.wf-p__modal-box');
      if (!box) return;
      lightStyle();
      box.classList.toggle('is-light', !!color && LIGHT_BG.indexOf(color.toLowerCase()) !== -1);
    }
    /* Neues Modell erst zeigen, wenn es geladen ist – nie kurz die falsche Farbe */
    function swapSrc(mv, src) {
      var cur = String(mv.getAttribute('src') || '').replace(/^https?:/, '');
      if (cur === String(src).replace(/^https?:/, '')) return;
      /* Vorschaubild des Standardmodells (weiß) durch ein leeres Bild ersetzen */
      mv.setAttribute('poster', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');
      mv.style.transition = 'opacity .3s ease';
      mv.style.opacity = '0';
      var box = mv.parentNode, wait = box && box.querySelector('[data-wf-model-loading]');
      if (box && !wait) {
        wait = document.createElement('p');
        wait.setAttribute('data-wf-model-loading', '');
        wait.setAttribute('role', 'status');
        wait.textContent = 'Wird geladen …';
        wait.style.cssText = 'position:absolute;left:0;right:0;top:50%;margin:0;transform:translateY(-50%);text-align:center;color:rgba(249,248,246,.68);font-size:16px;letter-spacing:.04em;pointer-events:none';
        box.appendChild(wait);
      }
      if (wait) wait.hidden = false;
      var done = function () {
        try { if (mv.dismissPoster) mv.dismissPoster(); } catch (e) {}
        if (wait) wait.hidden = true;
        mv.style.opacity = '1';
        mv.removeEventListener('load', done); mv.removeEventListener('error', done);
      };
      mv.addEventListener('load', done);
      mv.addEventListener('error', done);
      mv.setAttribute('src', src);
    }
    function applyColor(mv, list) {
      var m = modelFor(list || []);
      var l = colorLabel();
      if (l) l.textContent = m ? ' · ' + m.color : '';
      setBg(m ? m.color : '');
      if (m) swapSrc(mv, m.src);
      else if (mv.dataset.wfSrc && !mv.getAttribute('src')) mv.setAttribute('src', mv.dataset.wfSrc);
    }
    function showColor(mv) {
      if (!mv.dataset.wfSrc) mv.dataset.wfSrc = mv.getAttribute('src') || '';
      if (modelsList) { applyColor(mv, modelsList); return Promise.resolve(); }
      /* Liste noch nicht da: Standardmodell nicht anladen, sondern kurz warten */
      mv.removeAttribute('src');
      return loadModels().then(function (list) { applyColor(mv, list); });
    }
    function closeModel() { if (!modal) return; modal.hidden = true; document.body.classList.remove('wf-p-lock'); }
    if (modal && mOpen) {
      lightStyle();
      var pre = function () { loadModels(); };
      if ('requestIdleCallback' in window) requestIdleCallback(pre, { timeout: 3000 }); else setTimeout(pre, 1500);
      /* 3D-Bibliothek erst beim ersten Öffnen laden */
      var mvReady = function (cb) {
        if (window.customElements && customElements.get('model-viewer')) { cb(); return; }
        var done = function () { if (window.customElements && customElements.whenDefined) customElements.whenDefined('model-viewer').then(cb, cb); else cb(); };
        if (window.Shopify && typeof Shopify.loadFeatures === 'function') {
          try { Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12', onLoad: done }]); } catch (e) { done(); }
        } else done();
      };
      mOpen.addEventListener('click', function () {
        var mv = modal.querySelector('model-viewer');
        if (!mv) {
          var tpl = modal.querySelector('template[data-wf-model-tpl]');
          if (tpl) { tpl.parentNode.insertBefore(tpl.content.cloneNode(true), tpl); mv = modal.querySelector('model-viewer'); }
        }
        var reveal = function () { try { if (mv && mv.dismissPoster) mv.dismissPoster(); } catch (e) {} };
        if (mv) {
          mv.setAttribute('camera-controls', '');
          mv.setAttribute('interaction-prompt', 'none');
          mv.setAttribute('exposure', '0.6');
          showColor(mv).then(reveal, reveal);
        }
        modal.hidden = false;
        document.body.classList.add('wf-p-lock');
        reveal();
        /* Nach dem Einblenden (und sobald die 3D-Bibliothek bereit ist) Größe und Bildausschnitt neu berechnen */
        if (mv) mvReady(function () {
          reveal();
          requestAnimationFrame(function () {
            try { if (mv.updateFraming) mv.updateFraming(); } catch (e) {}
            try { if (mv.jumpCameraToGoal) mv.jumpCameraToGoal(); } catch (e) {}
          });
        });
        var x = modal.querySelector('.wf-p__modal-x'); if (x) x.focus();
      });
      $$('[data-wf-model-close]').forEach(function (b) { b.addEventListener('click', closeModel); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModel(); });
    }

    /* Raumansicht (AR) – eigener Block unter den Produktinformationen.
       Erscheint nur bei Produkten mit Farbmodellen (Vasen). iPhone: AR Quick Look (USDZ),
       Android: Scene Viewer (GLB), Desktop: QR-Code zur gewählten Farbe. */
    /* Bildrahmen je Modell in % des Vorschaubilds: oben, unten, Abstand Maßlinie rechts, Schatten Mitte, Schatten Breite */
    var RAUM_FIT = {
      luno: [5.9, 96.2, 10], tessa: [5.9, 96.3, 11], vyra: [7.0, 96.6, 15], mira: [7.3, 96.7, 13], sora: [6.3, 96.4, 17],
      aero: [2.9, 97.3, 0, 24, 38], manus: [2.9, 97.3, 0, 23, 38], poly: [2.9, 97.3, 0, 23, 38],
      /* mit Bambus-Sockel: 6. Wert = Unterkante des Halters (Maßlinie misst nur den Halter) */
      'aero-s': [3.0, 97.3, 0, 49.9, 88.3, 86.0], 'manus-s': [2.8, 97.4, 0, 49.6, 88.8, 86.0], 'poly-s': [2.8, 97.4, 0, 49.5, 89.0, 85.9]
    };
    var raumKey = '';
    function raumFit(sockel) {
      var fit = RAUM_FIT[raumKey + (sockel ? '-s' : '')] || RAUM_FIT[raumKey] || [6, 96.5, 8];
      var fig = raumEl && raumEl.querySelector('.wf-ar__fig');
      if (!fig) return;
      fig.style.setProperty('--t', fit[0] + '%'); fig.style.setProperty('--b', fit[1] + '%');
      fig.style.setProperty('--r', fit[2] + '%'); fig.style.setProperty('--sx', (fit[3] || 50) + '%');
      fig.style.setProperty('--sw', (fit[4] || 52) + '%'); fig.style.setProperty('--d', (fit[5] || fit[1]) + '%');
    }
    /* QR-Codes je Variante liegen als Shopify-Datei vor: wf-qr-<Varianten-ID>.png (Ziel: Produktseite mit Variante und #raum) */
    var RAUM_QR = 'https://cdn.shopify.com/s/files/1/0946/7917/1447/files/wf-qr-';
    var raumEl = null, raumMode = '', raumWine = false;
    function absUrl(u) { u = String(u || ''); return u.indexOf('//') === 0 ? 'https:' + u : u; }
    function sized(u, w) { u = absUrl(u); return u ? u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w : ''; }
    /* Handy erkennen: iPhone/iPad (auch iPadOS mit Desktop-Kennung) und Android.
       Nicht nur Safari mit AR-Kennung – sonst sieht man nach dem Scannen in Chrome/App-Browsern wieder den QR-Code. */
    function arModeOf() {
      var ua = navigator.userAgent || '';
      /* Mac-Safari kennt AR-Links auch, ist aber kein Handy → dort bleibt der QR-Code */
      if (/iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1)) return 'ios';
      if (/android/i.test(ua)) return 'android';
      return '';
    }
    function arLinkOk() {
      var a = document.createElement('a');
      return !!(a.relList && a.relList.supports && a.relList.supports('ar'));
    }
    function factOf(label) {
      var out = '';
      $$('.wf-p__mlist dt').forEach(function (dt) {
        if (dt.textContent.trim().toLowerCase() === label && dt.nextElementSibling) out = dt.nextElementSibling.textContent.trim();
      });
      return out;
    }
    function raumStyle() {
      if (document.getElementById('wf-p-raum-style')) return;
      var st = document.createElement('style');
      st.id = 'wf-p-raum-style';
      st.textContent =
        '.wf-ar{padding:clamp(40px,6vw,86px) 0 0}' +
        '.wf-ar__card{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.05fr);align-items:center;gap:clamp(24px,4vw,64px);padding:clamp(28px,4vw,56px);border-radius:24px;background:radial-gradient(110% 85% at 30% 42%,#2C2622 0%,#171412 75%);color:#F9F8F6;overflow:hidden;transition:background .3s ease}' +
        '.wf-ar__stage{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;min-height:420px}' +
        '.wf-ar__cap{margin:22px 0 0;max-width:340px;text-align:center;font-size:16px;line-height:1.45;color:rgba(249,248,246,.62)}' +
        '.wf-ar.is-light .wf-ar__cap{color:rgba(21,18,15,.66)}' +
        '.wf-ar__fig{position:relative;width:380px;max-width:100%;aspect-ratio:1/1}' +
        '.wf-ar__fig img{position:relative;z-index:1;display:block;width:100%;height:100%;object-fit:contain;transition:opacity .3s ease}' +
        '.wf-ar__fig::after{content:"";position:absolute;z-index:0;left:var(--sx,50%);top:calc(var(--b) - 9px);width:var(--sw,52%);height:18px;transform:translateX(-50%);background:radial-gradient(50% 50% at 50% 50%,rgba(0,0,0,.55),transparent)}' +
        '.wf-ar__floor{position:absolute;left:-18%;right:-18%;top:var(--b);height:1px;background:linear-gradient(90deg,transparent,rgba(249,248,246,.35),transparent)}' +
        '.wf-ar__dim{position:absolute;right:var(--r);top:var(--t);height:calc(var(--d,var(--b)) - var(--t));width:1px;background:rgba(210,181,138,.55)}' +
        '.wf-ar__dim::before,.wf-ar__dim::after{content:"";position:absolute;left:-5px;width:11px;height:1px;background:rgba(210,181,138,.8)}' +
        '.wf-ar__dim::before{top:0}.wf-ar__dim::after{bottom:0}' +
        '.wf-ar__dim span{position:absolute;top:50%;left:12px;transform:translateY(-50%);white-space:nowrap;color:#D2B58A;font-size:16px;font-weight:700}' +
        '.wf-ar__eyebrow{margin:0;color:#D2B58A;font-size:16px;line-height:1.2;font-weight:700;letter-spacing:.14em;text-transform:uppercase;display:flex;align-items:center;gap:12px}' +
        '.wf-ar__eyebrow::before{content:"";width:24px;height:1px;background:currentColor;opacity:.7}' +
        '.wf-ar h2{margin:14px 0 16px;font-family:inherit;font-size:clamp(32px,3.4vw,48px);line-height:1.04;letter-spacing:-.03em;font-weight:400;color:#F9F8F6}' +
        '.wf-ar__text{margin:0;color:rgba(249,248,246,.8);font-size:17px;line-height:1.65;max-width:520px}' +
        '.wf-ar__chosen{margin:18px 0 0;display:flex;flex-wrap:wrap;gap:6px 14px;font-size:16px;color:rgba(249,248,246,.7)}' +
        '.wf-ar__chosen strong{color:#F9F8F6;font-weight:700}' +
        '.wf-ar__go{margin-top:26px;display:flex;align-items:center;gap:22px;flex-wrap:wrap}' +
        '.wf-ar__btn{height:56px;padding:0 28px;border:0;border-radius:999px;background:#A5523D;color:#fff!important;display:inline-flex;align-items:center;justify-content:center;gap:10px;font:inherit;font-size:17px;font-weight:700;cursor:pointer;box-shadow:0 12px 28px rgba(0,0,0,.25)}' +
        '.wf-ar__btn:hover{filter:brightness(.92)}' +
        '.wf-ar__btn:focus-visible{outline:2px solid #D2B58A;outline-offset:3px}' +
        '.wf-ar__btn svg{width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.7;stroke-linecap:round;stroke-linejoin:round}' +
        '.wf-ar__qr{display:flex;align-items:center;gap:16px}' +
        '.wf-ar__qr img{display:block;width:111px;height:111px;box-sizing:content-box;border-radius:12px;background:#fff;padding:10px;image-rendering:pixelated;image-rendering:crisp-edges}' +
        '.wf-ar__qr p{margin:0;font-size:16px;line-height:1.45;color:rgba(249,248,246,.8);max-width:240px}' +
        '.wf-ar__qr strong{display:block;color:#F9F8F6}' +
        '.wf-ar__note{margin:22px 0 0;font-size:16px;color:rgba(249,248,246,.62)}' +
        '.wf-ar.is-qr .wf-ar__btn,.wf-ar.is-ar .wf-ar__qr{display:none}' +
        '.wf-ar.is-light .wf-ar__card{background:radial-gradient(110% 85% at 30% 42%,#EFEBE5 0%,#E4E0DA 75%);color:#15120F}' +
        '.wf-ar.is-light .wf-ar__fig::after{background:radial-gradient(50% 50% at 50% 50%,rgba(0,0,0,.28),transparent)}' +
        '.wf-ar.is-light .wf-ar__floor{background:linear-gradient(90deg,transparent,rgba(21,18,15,.28),transparent)}' +
        '.wf-ar.is-light .wf-ar__dim{background:rgba(122,94,58,.55)}' +
        '.wf-ar.is-light .wf-ar__dim::before,.wf-ar.is-light .wf-ar__dim::after{background:rgba(122,94,58,.85)}' +
        '.wf-ar.is-light .wf-ar__dim span,.wf-ar.is-light .wf-ar__eyebrow{color:#7A5E3A}' +
        '.wf-ar.is-light h2,.wf-ar.is-light .wf-ar__chosen strong,.wf-ar.is-light .wf-ar__qr strong{color:#15120F}' +
        '.wf-ar.is-light .wf-ar__text,.wf-ar.is-light .wf-ar__qr p{color:rgba(21,18,15,.8)}' +
        '.wf-ar.is-light .wf-ar__chosen{color:rgba(21,18,15,.7)}' +
        '.wf-ar.is-light .wf-ar__note{color:rgba(21,18,15,.66)}' +
        '.wf-ar.is-light .wf-ar__qr img{box-shadow:0 0 0 1px rgba(21,18,15,.12)}' +
        '.wf-ar.is-light .wf-ar__btn{box-shadow:0 12px 28px rgba(0,0,0,.14)}' +
        '@media (max-width:749px){' +
          '.wf-ar__card{grid-template-columns:1fr;padding:28px 20px 30px;border-radius:20px;gap:8px}' +
          '.wf-ar__stage{min-height:0;padding-top:26px}' +
          '.wf-ar__fig{width:250px}' +
          '.wf-ar__cap{margin:14px 0 22px}' +
          '.wf-ar__dim span{top:-28px;left:auto;right:-6px;transform:none}' +
          '.wf-ar h2{font-size:32px}' +
          '.wf-ar__text{font-size:16px}' +
          '.wf-ar__btn{width:100%}' +
        '}' +
        '@media (prefers-reduced-motion:reduce){.wf-ar__card,.wf-ar__fig img{transition:none}}';
      document.head.appendChild(st);
    }
    function raumBuild(list) {
      if (raumEl || !list || !list.length) return;
      var band = $('.wf-p__band');
      if (!band || !band.parentNode) return;
      var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
      raumKey = h.replace(/^(vase|wine-dock)-/, '');
      raumStyle();
      raumMode = arModeOf();
      raumWine = !factOf('durchmesser') && !!factOf('länge');
      var sid = root.getAttribute('data-section') || 'p';
      var sec = document.createElement('section');
      sec.className = 'wf-ar ' + (raumMode ? 'is-ar' : 'is-qr');
      sec.id = 'raum';
      sec.setAttribute('aria-labelledby', 'wf-ar-t-' + sid);
      sec.innerHTML =
        '<div class="wf-p__inner"><div class="wf-ar__card">' +
          '<div class="wf-ar__stage">' +
            '<div class="wf-ar__fig">' +
              '<img alt="" width="900" height="900" loading="lazy" decoding="async" data-ar-img>' +
              '<span class="wf-ar__floor" aria-hidden="true"></span>' +
              '<span class="wf-ar__dim" aria-hidden="true"><span data-ar-dim></span></span>' +
            '</div>' +
            '<p class="wf-ar__cap" data-ar-cap></p>' +
          '</div>' +
          '<div class="wf-ar__copy">' +
            '<p class="wf-ar__eyebrow">Raumansicht</p>' +
            '<h2 id="wf-ar-t-' + sid + '">' + (raumWine ? 'Wie er bei dir wirkt.' : 'Wie sie bei dir wirkt.') + '</h2>' +
            '<p class="wf-ar__text" data-ar-text></p>' +
            '<p class="wf-ar__chosen"><span>Gewählt: <strong data-ar-color></strong></span><span data-ar-size></span></p>' +
            '<div class="wf-ar__go">' +
              '<div class="wf-ar__qr">' +
                '<img alt="QR-Code: öffnet diese Seite auf dem Handy" width="111" height="111" data-ar-qr>' +
                '<p><strong data-ar-qr-t>Mit dem Handy scannen</strong>Die Seite öffnet sich mit deiner Auswahl auf deinem Handy.</p>' +
              '</div>' +
              '<button type="button" class="wf-ar__btn" data-ar-go>' +
                '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z"/><path d="M12 12l8-4.5M12 12v9M12 12L4 7.5"/></svg>' +
                'In deinem Raum ansehen' +
              '</button>' +
            '</div>' +
            '<p class="wf-ar__note">Auf iPhones und Android-Handys mit aktueller Software – ganz ohne App.</p>' +
          '</div>' +
        '</div></div>';
      band.parentNode.insertBefore(sec, band.nextSibling);
      raumEl = sec;
      var hgt = factOf('höhe'), dia = factOf('durchmesser'), len = factOf('länge');
      var second = raumWine ? (len ? len + ' lang' : '') : (dia ? 'Ø ' + dia : '');
      sec.querySelector('[data-ar-dim]').textContent = hgt;
      sec.querySelector('[data-ar-size]').textContent = (hgt ? hgt + ' hoch' : '') + (hgt && second ? ' · ' : '') + second;
      sec.querySelector('[data-ar-go]').addEventListener('click', raumGo);
      raumUpdate();
      if (location.hash === '#raum') setTimeout(function () {
        /* Vom QR-Code kommend: auf dem Handy direkt zum Knopf, sonst zum Blockanfang */
        if (raumMode) sec.querySelector('[data-ar-go]').scrollIntoView({ block: 'center' });
        else sec.scrollIntoView({ block: 'start' });
      }, 60);
    }
    function raumCurrent() {
      var hit = modelsList && modelFor(modelsList);
      if (hit) return hit;
      var m = modelsList && modelsList[0];
      return m ? { src: m.src, color: '', m: m } : null;
    }
    function raumUpdate() {
      if (!raumEl) return;
      var hit = raumCurrent();
      if (!hit) return;
      var m = hit.m, color = hit.color, sockel = m.alt.indexOf('mit bambus-sockel') !== -1;
      raumFit(sockel);
      raumEl.querySelector('[data-ar-cap]').textContent =
        (raumWine ? (sockel ? 'Digitales Modell mit Bambus-Sockel, ohne Flasche. ' : 'Digitales Modell, ohne Flasche. ') : 'Digitales Modell. ') +
        'Das gedruckte Original zeigt feine Schichtlinien aus der Fertigung.';
      raumEl.classList.toggle('is-light', !!color && LIGHT_BG.indexOf(color.toLowerCase()) !== -1);
      raumEl.querySelector('[data-ar-text]').textContent = 'Stell ' + m.name + ' mit deinem Handy auf ' +
        (raumWine ? 'deinen Esstisch, dein Sideboard oder die Hausbar' : 'deinen Tisch, dein Sideboard oder die Fensterbank') +
        ' – in Originalgröße und in der Farbe, die du gewählt hast. So siehst du vor der Bestellung, wie Form und Farbe in deinem Raum wirken.';
      raumEl.querySelector('[data-ar-color]').textContent = color || '–';
      var img = raumEl.querySelector('[data-ar-img]');
      var src = sized(m.preview, 900);
      if (src && img.getAttribute('src') !== src) {
        var set = sized(m.preview, 500) + ' 500w, ' + src + ' 900w';
        var put = function () { img.setAttribute('srcset', set); img.setAttribute('src', src); img.style.opacity = '1'; };
        img.alt = m.name + (color ? ' in ' + color : '');
        img.setAttribute('sizes', '(max-width: 749px) 250px, 380px');
        if (img.getAttribute('src')) {
          /* Farbwechsel: neues Bild erst zeigen, wenn es geladen ist */
          img.style.opacity = '0';
          var pre = new Image();
          pre.onload = pre.onerror = put;
          pre.sizes = img.sizes; pre.srcset = set; pre.src = src;
        } else put();
      }
      var q = raumEl.querySelector('[data-ar-qr]'), vid = String((idInput && idInput.value) || '');
      if (vid && q.getAttribute('data-ar-vid') !== vid) {
        q.setAttribute('data-ar-vid', vid);
        q.onload = function () { q.hidden = false; raumEl.querySelector('[data-ar-qr-t]').textContent = 'Mit dem Handy scannen'; };
        q.onerror = function () { q.hidden = true; raumEl.querySelector('[data-ar-qr-t]').textContent = 'Auf dem Handy öffnen'; };
        q.src = RAUM_QR + vid + '.png';
      }
    }
    function raumGo() {
      var hit = raumCurrent();
      if (!hit) return;
      var m = hit.m, title = m.name + (hit.color ? ' · ' + hit.color : '');
      if (raumMode === 'ios' && m.usdz) {
        /* Browser ohne AR-Link (z. B. Chrome am iPhone): Modell direkt öffnen, iOS zeigt es in der AR-Ansicht */
        if (!arLinkOk()) { location.href = absUrl(m.usdz) + '#allowsContentScaling=0'; return; }
        var a = document.createElement('a');
        a.setAttribute('rel', 'ar');
        a.href = absUrl(m.usdz) + '#allowsContentScaling=0';
        a.appendChild(document.createElement('img'));
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { a.remove(); }, 1000);
        return;
      }
      if (m.src) {
        var back = location.href.split('#')[0];
        location.href = 'intent://arvr.google.com/scene-viewer/1.0?file=' + encodeURIComponent(absUrl(m.src)) +
          '&mode=ar_preferred&resizable=false&title=' + encodeURIComponent(title) +
          '#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;' +
          'S.browser_fallback_url=' + encodeURIComponent(back) + ';end;';
      }
    }
    loadModels().then(raumBuild);
  }

  function boot() { [].slice.call(document.querySelectorAll('[data-wf-p]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
